import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import {
  changePhoneNumberConfirm,
  changePhoneNumberReject
} from '../../settings/ChangePhoneNumber/actions';
import { getNewPhoneNumber } from '../../settings/ChangePhoneNumber/selectors';

const MobileNumberConfirmation = ({ newPhoneNumber, confirm, reject }) => (
  <div className="modal">
    <div className="modal__header">
      Confirm number
    </div>
    <p className="modal__paragraph">
      {newPhoneNumber}
    </p>
    <p className="modal__paragraph">
      Please make sure this is the correct number.<br />
      Your account will transfer to and will only be accessible from this mobile number
    </p>
    <div className="modal__button-line">
      <Button className="modal__button" onClick={confirm}>Confirm</Button>
      <Button className="modal__button" onClick={reject}>Cancel</Button>
    </div>
  </div>
);

MobileNumberConfirmation.propTypes = {
  newPhoneNumber: PropTypes.string.isRequired,
  confirm: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  newPhoneNumber: getNewPhoneNumber(state)
});

const mapDispatchToProps = {
  confirm: changePhoneNumberConfirm,
  reject: changePhoneNumberReject
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileNumberConfirmation);
